"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSplitterBalanceButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const release_1 = require("./release");
const PaymentSplitterBalanceButton = props => {
    const { className, contract, disabled, variant } = props;
    const [isPaymentSplitterBalanceDialogOpen, setIsPaymentSplitterBalanceDialogOpen] = (0, react_1.useState)(false);
    const handlePaymentSplitterBalance = () => {
        setIsPaymentSplitterBalanceDialogOpen(true);
    };
    const handlePaymentSplitterBalanceCancel = () => {
        setIsPaymentSplitterBalanceDialogOpen(false);
    };
    const handlePaymentSplitterBalanceConfirm = () => {
        setIsPaymentSplitterBalanceDialogOpen(false);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handlePaymentSplitterBalance, icon: icons_material_1.MonetizationOn, message: "form.buttons.paymentSplitterBalance", className: className, dataTestId: "PaymentSplitterBalanceButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(release_1.PaymentSplitterBalanceDialog, { onCancel: handlePaymentSplitterBalanceCancel, onConfirm: handlePaymentSplitterBalanceConfirm, open: isPaymentSplitterBalanceDialogOpen, data: { contract } })] }));
};
exports.PaymentSplitterBalanceButton = PaymentSplitterBalanceButton;
//# sourceMappingURL=index.js.map